import { makeAutoObservable } from 'mobx'
import { restClient } from '@/Core'
import type { Notify } from '@/Ship/Contracts/Notify'

/**
 * Local store of `ConfirmExecutionModal`.
 * Owns dispatcher's optional comment, submission flag, and the confirm-execution request.
 * Instantiated per modal mount via `useState(() => new ConfirmExecutionModalStore())`.
 */
export class ConfirmExecutionModalStore {
    comment = ''
    loading = false

    constructor() {
        makeAutoObservable(this)
    }

    setComment(v: string): void {
        this.comment = v
    }

    setLoading(v: boolean): void {
        this.loading = v
    }

    reset(): void {
        this.comment = ''
    }

    async confirm(assignmentUuid: string, assignmentStatus: string, notify: Notify): Promise<boolean> {
        const commentRequired = assignmentStatus !== 'completed_by_driver'
        if (commentRequired && !this.comment.trim()) return false
        this.setLoading(true)
        try {
            await restClient.post(`/services/executor-assignments/${assignmentUuid}/confirm-execution`, {
                json: { dispatcherComment: this.comment || null },
            })
            notify.success('Виконання підтверджено')
            this.reset()
            return true
        } catch {
            notify.error('Помилка підтвердження')
            return false
        } finally {
            this.setLoading(false)
        }
    }
}
